export function LocalityListParser (localityList = []) {
  return localityList
    .map(({ id, name, abbreviation, state_code: stateCode }) => ({
      value: id,
      label: name,
      initials: abbreviation || stateCode
    }))
    .sort((a, b) => a.label.localeCompare(b.label))
}
